import React, { Component } from "react";
import { connect } from "react-redux";
import * as configurationThunks from "../redux/thunks/configurationThunks";
import { Translate, withLocalize } from "react-localize-redux";
import Grid from "@material-ui/core/Grid";
import OrdersContainer from "./OrdersContainer";

class DisplayContainer extends Component {
  componentWillMount = () => {
    this.props.getLanguage();
  };

  componentDidUpdate(prevProps) {
    if (
      !this.props.languageCode ||
      prevProps.languageCode === this.props.languageCode
    ) {
      return;
    }
    this.props.setActiveLanguage(this.props.languageCode);
  }

  render() {
    return (
      <div className="flex-container h-100 w-100" style={{ position: "fixed" }}>
        <div className="w-100 h-100">
          <h1 className="text-centered">
            {this.props.showPreparationView &&
              this.props.showReadyToPickUpView && <Translate id="OrderQueue" />}
          </h1>

          <Grid container>
            {this.props.showPreparationView && (
              <Grid item xs className="flex-item in-progress">
                <div className="label">
                  {this.props.showReadyToPickUpView ? (
                    <Translate id="InProgress" />
                  ) : (
                    <Translate id="OrdersInProgress" />
                  )}
                </div>
                <OrdersContainer
                  orders={this.props.pendingOrders}
                  pageSize={
                    this.props.showPreparationView &&
                    this.props.showReadyToPickUpView
                      ? 24
                      : 48
                  }
                />
              </Grid>
            )}
            {this.props.showReadyToPickUpView && (
              <Grid item xs className="flex-item ready">
                <div className="label">
                  {this.props.showPreparationView ? (
                    <Translate id="Ready" />
                  ) : (
                    <Translate id="OrdersReady" />
                  )}
                </div>
                <OrdersContainer
                  orders={this.props.readyOrders}
                  pageSize={
                    this.props.showPreparationView &&
                    this.props.showReadyToPickUpView
                      ? 21
                      : 42
                  }
                />
              </Grid>
            )}
          </Grid>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pendingOrders: state.orders.pendingOrders,
    readyOrders: state.orders.readyOrders,
    languageCode: state.configuration.languageCode,
    showReadyToPickUpView: state.configuration.showReadyToPickUpView,
    showPreparationView: state.configuration.showPreparationView
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getLanguage: () => dispatch(configurationThunks.getLanguage())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withLocalize(DisplayContainer));



// WEBPACK FOOTER //
// ./src/containers/DisplayContainer.js